module.exports = __webpack_public_path__ + "testerstatic/media/illus-success.4e5bcd6d.svg";